/*
 * Collection search box (snippets/themporium-collection-search.liquid).
 * On first use it loads every product in the collection as ready-made cards from
 * sections/themporium-search-index.liquid, then matches as you type. Matching is forgiving:
 * word starts, small typos ("candel", "lavendar"), US spellings ("jewelry", "mom") and a few
 * gift words ("xmas", "nan") all find the right products. Titles count most, then product
 * type, collections and tags, then the description. While a search is showing, the normal
 * grid and filters step aside; clearing the box brings them back.
 */
(function () {
  'use strict';
  if (customElements.get('tp-collection-search')) return;

  var STOP = { a: 1, an: 1, and: 1, the: 1, for: 1, of: 1, to: 1, with: 1, in: 1, on: 1, my: 1, her: 1, his: 1, their: 1, gift: 1, gifts: 1, present: 1, presents: 1, some: 1, something: 1 };
  var SYN = {
    mom: 'mum', mommy: 'mum', mother: 'mum', mummy: 'mum', mam: 'mum',
    father: 'dad', daddy: 'dad', papa: 'dad',
    grandma: 'nan', granny: 'nan', nanny: 'nan', nana: 'nan', gran: 'nan', grandmother: 'nan',
    grandad: 'grandpa', granddad: 'grandpa', grandfather: 'grandpa',
    xmas: 'christmas', crimbo: 'christmas', festive: 'christmas',
    jewelry: 'jewellery', color: 'colour', colors: 'colours', gray: 'grey', cozy: 'cosy',
    personalized: 'personalised', personalize: 'personalised', custom: 'personalised', customised: 'personalised', customized: 'personalised', named: 'name',
    sweater: 'jumper', stocking: 'stocking', stuffer: 'filler', stuffers: 'fillers',
    candles: 'candle', mugs: 'mug', cups: 'mug', cup: 'mug',
    baby: 'baby', newborn: 'baby', infant: 'baby',
    spa: 'spa', pamper: 'pamper', pampering: 'pamper', selfcare: 'self care',
    tea: 'tea', teas: 'tea'
  };
  var WEIGHTS = { title: 3, type: 2, coll: 1.6, tags: 1.4, text: 0.6 };

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function words(s) {
    var out = [];
    norm(s).split(' ').forEach(function (w) { if (w) { out.push(w); var syn = SYN[w]; if (syn && syn !== w) out = out.concat(syn.split(' ')); } });
    return out;
  }
  // A query word can stand for several product words ("jewelry" finds necklaces too).
  var ALSO = {
    jewellery: ['jewellery', 'necklace', 'earrings', 'bracelet', 'pendant'],
    necklace: ['necklace', 'pendant'],
    mum: ['mum', 'mother'],
    dad: ['dad', 'father', 'gentleman', 'gentlemans'],
    nan: ['nan', 'grandma', 'gran', 'granny'],
    pamper: ['pamper', 'spa', 'bath', 'relax', 'self'],
    spa: ['spa', 'pamper', 'bath'],
    garden: ['garden', 'gardener', 'gardeners', 'gardening', 'plant', 'planter'],
    gardener: ['gardener', 'gardeners', 'garden', 'gardening'],
    book: ['book', 'bookish', 'bookmark', 'reader', 'reading'],
    reader: ['reader', 'reading', 'book', 'bookish', 'bookmark'],
    decoration: ['decoration', 'decorations', 'ornament', 'bauble', 'hanging'],
    ornament: ['ornament', 'bauble', 'decoration'],
    bauble: ['bauble', 'ornament', 'decoration']
  };
  function queryTokens(q) {
    var toks = [];
    norm(q).split(' ').forEach(function (w) {
      if (!w || STOP[w]) return;
      var base = SYN[w] ? SYN[w].split(' ')[0] : w;
      toks.push(ALSO[base] || [base]);
    });
    return toks;
  }
  // Damerau-Levenshtein distance, giving up early once it is past max.
  function dist(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev2 = null, prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      var rowMin = i;
      for (j = 1; j <= b.length; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (prev2 && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v;
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[b.length];
  }
  // How well one query word matches one product word, 0 to 1.
  function wordScore(t, w) {
    if (t === w) return 1;
    if (w.indexOf(t) === 0) return t.length >= 3 && w.length - t.length <= 4 ? 0.85 : 0.6;
    if (t.length >= 4 && w.indexOf(t) > 0) return 0.55;
    if (t.length < 4) return 0;
    var allowed = t.length >= 7 ? 2 : 1;
    if (t[0] !== w[0]) return 0; // typos rarely hit the first letter, and this stops "calendar" matching "lavendar"
    var d = dist(t, w.length > t.length + allowed ? w.slice(0, t.length + allowed) : w, allowed);
    if (d > allowed) return 0;
    if (d === 0) return 0.8; // the start of a longer word, with the typo fixed
    return d === 1 ? 0.7 : 0.45;
  }
  function tokenScore(alts, entry) {
    var best = 0;
    for (var a = 0; a < alts.length; a++) {
      // the word the shopper typed counts in full; stand-ins count a little less
      var s = fieldScore(alts[a], entry) * (a === 0 ? 1 : 0.8);
      if (s > best) best = s;
    }
    return best;
  }
  function fieldScore(t, entry) {
    var best = 0;
    for (var f in WEIGHTS) {
      var ws = entry[f], fb = 0;
      for (var k = 0; k < ws.length && fb < 1; k++) {
        var s = wordScore(t, ws[k]);
        if (f === 'text' && s < 0.85) s = 0; // descriptions only count for clean matches, not typos
        if (s > fb) fb = s;
      }
      if (fb * WEIGHTS[f] > best) best = fb * WEIGHTS[f];
    }
    return best;
  }

  class TpCollectionSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.tp-csearch__input');
      this.clearBtn = this.querySelector('.tp-csearch__clear');
      this.status = this.querySelector('.tp-csearch__status');
      this.results = this.querySelector('.tp-csearch__results');
      this.entries = null;
      this.loading = null;
      this.timer = 0;
      var self = this;
      var warm = function () { self.load(); };
      this.input.addEventListener('focus', warm, { once: true });
      this.input.addEventListener('pointerenter', warm, { once: true });
      this.input.addEventListener('input', function () { self.queue(); });
      this.input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { self.clear(); } });
      this.clearBtn.addEventListener('click', function () { self.clear(); self.input.focus(); });
      // A filter or sort change means the shopper has moved on from the search.
      document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm, .facets') && self.input.value) self.clear(); });
      var start = new URLSearchParams(location.search).get('find');
      if (start) { this.input.value = start; this.queue(); }
    }

    load() {
      if (this.loading) return this.loading;
      var self = this;
      var base = this.dataset.url;
      function page(n) {
        return fetch(base + '?section_id=themporium-search-index' + (n > 1 ? '&page=' + n : ''), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
      }
      this.loading = page(1).then(function (doc) {
        var list = doc.querySelector('.tp-search-index');
        var pages = list ? parseInt(list.dataset.pages, 10) || 1 : 1;
        var docs = [Promise.resolve(doc)];
        for (var n = 2; n <= Math.min(pages, 8); n++) docs.push(page(n));
        return Promise.all(docs);
      }).then(function (docs) {
        var entries = [];
        docs.forEach(function (doc) {
          doc.querySelectorAll('.tp-search-index > li').forEach(function (li) {
            var d = li.dataset;
            li.classList.remove('scroll-trigger', 'animate--slide-in');
            li.querySelectorAll('.scroll-trigger').forEach(function (el) { el.classList.remove('scroll-trigger', 'animate--slide-in'); });
            entries.push({
              el: document.importNode(li, true),
              order: entries.length,
              title: words(d.tpTitle), type: words(d.tpType), coll: words(d.tpCollections),
              tags: words(d.tpTags), text: words(d.tpText)
            });
          });
        });
        self.entries = entries;
        return entries;
      }).catch(function () {
        self.loading = null;
        self.entries = null;
      });
      return this.loading;
    }

    queue() {
      var self = this;
      window.clearTimeout(this.timer);
      this.clearBtn.hidden = !this.input.value;
      if (!this.input.value.trim()) { this.clear(true); return; }
      this.timer = window.setTimeout(function () { self.run(); }, 140);
    }

    run() {
      var self = this;
      var q = this.input.value.trim();
      var toks = queryTokens(q);
      if (!toks.length || q.length < 2) { this.showGrid(true); this.status.textContent = ''; return; }
      if (!this.entries) {
        this.status.textContent = 'Searching...';
        this.load().then(function () { if (self.entries) self.run(); else self.status.textContent = 'Search is not available right now. Please use the filters below.'; });
        return;
      }
      var all = [], some = [];
      // "gift" is too common to search on, but someone typing it is after a gift, so ready-made sets and boxes go first
      var wantsGift = /\bgifts?\b|\bpresents?\b/.test(norm(q));
      this.entries.forEach(function (e) {
        var total = 0, hit = 0;
        toks.forEach(function (t) { var s = tokenScore(t, e); if (s > 0) { hit++; total += s; } });
        if (hit && wantsGift && (e.title.indexOf('gift') > -1 || e.title.indexOf('set') > -1 || e.title.indexOf('box') > -1 || e.title.indexOf('hamper') > -1)) total += 1;
        if (hit === toks.length) all.push({ e: e, s: total });
        else if (hit > 0) some.push({ e: e, s: total, h: hit });
      });
      var list = all;
      if (!list.length && toks.length > 1) {
        list = some.sort(function (a, b) { return b.h - a.h || b.s - a.s; });
      }
      list.sort(function (a, b) { return b.s - a.s || a.e.order - b.e.order; });
      this.render(list.map(function (x) { return x.e; }), q, list === all);
      try { var u = new URL(location.href); u.searchParams.set('find', q); history.replaceState(history.state, '', u); } catch (e) {}
    }

    render(items, q, exact) {
      var grid = document.getElementById('product-grid');
      var ul = document.createElement('ul');
      ul.className = grid ? grid.className : 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop';
      ul.removeAttribute('id');
      items.forEach(function (e) { ul.appendChild(e.el); });
      this.results.textContent = '';
      this.results.appendChild(ul);
      var scope = this.dataset.scope;
      if (!items.length) {
        this.status.textContent = 'Nothing matches "' + q + '" ' + scope + ' yet. Try another word, or clear the search to browse.';
      } else {
        var n = items.length + (items.length === 1 ? ' gift' : ' gifts');
        this.status.textContent = exact ? n + ' ' + scope + ' for "' + q + '"' : 'No exact match for "' + q + '", so here ' + (items.length === 1 ? 'is the closest gift' : 'are the ' + items.length + ' closest gifts');
      }
      this.showGrid(false);
    }

    showGrid(show) {
      var grid = document.getElementById('ProductGridContainer');
      var facets = document.getElementById('main-collection-filters');
      var sort = document.querySelector('.facets-vertical-sort');
      [grid, facets, sort].forEach(function (el) { if (el) el.classList.toggle('tp-csearch-hidden', !show); });
      this.results.hidden = show;
      this.classList.toggle('is-active', !show);
    }

    clear(keepText) {
      window.clearTimeout(this.timer);
      if (!keepText) this.input.value = '';
      this.clearBtn.hidden = !this.input.value;
      this.status.textContent = '';
      this.results.textContent = '';
      this.showGrid(true);
      try { var u = new URL(location.href); if (u.searchParams.has('find')) { u.searchParams.delete('find'); history.replaceState(history.state, '', u); } } catch (e) {}
    }
  }

  customElements.define('tp-collection-search', TpCollectionSearch);
})();
